import i18n from '@/helpers/i18n';
import { isRestrictedUser } from '@/helpers/permissions';

const RESTRICTED_PATHS = new Set([
  '/produtos/lista',
  '/paginas/lista',
  '/perfil',
  '/logout',
]);

function buildMenu() {
  const items = [
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('mainProducts'),
      to: '/produtos/lista',
      icon: 'cil-pin',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('members'),
      to: '/membros/lista',
      icon: 'cil-people',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('prizes'),
      to: '/premios/lista',
      icon: 'cil-pin',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('heros'),
      to: '/capa/lista',
      icon: 'cil-library',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('keyValues'),
      to: '/informacoes/lista',
      icon: 'cil-library',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('staticInfos'),
      to: '/paginas/lista',
      icon: 'cil-File',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('menuItems'),
      to: '/menu/lista',
      icon: 'cil-list',
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('settings'),
      to: '/definicoes',
      icon: 'cil-settings'
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('profile'),
      to: '/perfil',
      icon: 'cil-user'
    },
    {
      _name: 'CSidebarNavItem',
      name: i18n.t('logout'),
      to: '/logout',
      icon: 'cil-power-standby'
    },
  ];

  const visible = isRestrictedUser()
    ? items.filter(item => RESTRICTED_PATHS.has(item.to))
    : items;

  return [
    {
      _name: 'CSidebarNav',
      _children: [
        { _name: 'CSidebarNavTitle' },
        ...visible,
        { _name: 'CSidebarNavTitle' }
      ]
    }
  ];
}

export default buildMenu;
